module.exports = __webpack_public_path__ + "static/media/solution13.061112b7.jfif";